<template>
  <div class="time-group-slider">
    <span class="start">{{ $t('SystemMaintenance.StartTime') }}<br>{{ Object.keys(newDateObject)[0] }}</span>
    <span class="end">{{ $t('SystemMaintenance.EndTime') }}<br>{{ Object.keys(newDateObject)[Object.keys(newDateObject).length-1] }}</span>
    <div class="wrapper" :class="[isScrollable?'is-scrollable':'']">
      <span v-if="isScrollable" class="pre" @click="handlePre"><i class="el-icon-caret-left" /></span>
      <span v-if="isScrollable" class="next" @click="handleNext"><i class="el-icon-caret-right" /></span>
      <div ref="scroller" class="scroller" :style="!isScrollable?`text-align:${align}`:''">
        <div ref="btn-group" class="button-group" :style="`left:${offsetWidth}px`">
          <div v-for="date in Object.keys(newDateObject)" :key="date" class="dataItem">
            <span class="label">{{ date }}</span>
            <div v-for="time in timeList" :key="time" class="time-item" :class="[newDateObject[date].indexOf(time)!==-1?'active':'']" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeGroupSlider',
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    align: {
      type: String,
      default: () => 'left'
    },
    dateObject: {
      type: Object,
      default: () => {}
    },
    timeArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isScrollable: false,
      offsetWidth: 0,
      timer: null
    }
  },
  computed: {
    timeList() {
      return this.timeArr.reduce((result, item) => {
        return result.concat(item)
      }, [])
    },
    newDateObject() {
      const { dateObject } = this
      const newObject = {}
      Object.keys(dateObject).forEach(date => {
        newObject[date] = dateObject[date].reduce((result, item) => {
          return result.concat(item)
        }, [])
      })
      return newObject
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.resizeHandler()
    }, 500)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resizeHandler() {
      const scroller = this.$refs.scroller
      const btnGroup = this.$refs['btn-group']
      if (btnGroup.offsetWidth > scroller.offsetWidth) {
        if (!this.isScrollable) {
          this.isScrollable = true
        }
      } else {
        this.isScrollable = false
        this.offsetWidth = 0
      }
    },
    handlePre() {
      const scroller = this.$refs.scroller
      if (Math.abs(this.offsetWidth) > 0 && Math.abs(this.offsetWidth) >= scroller.offsetWidth) {
        this.offsetWidth += scroller.offsetWidth
      } else {
        this.offsetWidth = 0
      }
    },
    handleNext() {
      const scroller = this.$refs.scroller
      const btnGroup = this.$refs['btn-group']
      const widthDiff = btnGroup.offsetWidth - scroller.offsetWidth
      if (widthDiff > Math.abs(this.offsetWidth)) {
        const offsetDiff = widthDiff - Math.abs(this.offsetWidth)
        if (offsetDiff > scroller.offsetWidth) {
          this.offsetWidth -= scroller.offsetWidth
        } else {
          this.offsetWidth -= offsetDiff
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.time-group-slider {
  position: relative;
  margin-top: 10px;
  flex: 1;
  overflow: hidden;
  background-color: #fff;
  padding:0 100px;
  .start,.end{
    position: absolute;
    top:50%;
    transform: translateY(-50%);
  }
  .start {
    left: 10px;
  }
  .end {
    right: 10px;
  }
  .wrapper {
    position: relative;
    .scroller{
      overflow: hidden;
      .button-group {
        position: relative;
        height: 60px;
        padding-left:30px;
        white-space: nowrap;
        display: inline-block;
      }
    }
    &.is-scrollable{
      padding: 0 20px;
      .pre,.next{
        position:absolute;
        cursor: pointer;
        i{
          font-size: 20px;
          line-height: 91px;
          color: $--color-text-secondary;
          &:hover {
            color: $--color-primary;
          }
        }
      }
      .pre {
        left: 0;
      }
      .next {
        right: 0;
      }
    }
  }
  .dataItem {
    position: relative;
    display: inline-block;
    width: 96px;
    border-top:1px solid #000;
    margin-top: 30px;
    .label {
      top:-25px;
      position: absolute;
      transform:translateX(-50%);
    }
    &:before {
      position: absolute;
      content: '';
      display: inline-block;
      width: 1px;
      height: 8px;
      background-color: #000;
      top:0;
    }
    &:last-child {
      &:after {
        position: absolute;
        content: '';
        display: inline-block;
        width: 1px;
        height: 8px;
        background-color: #000;
        top:0;
        right: 0;
      }
    }
    .time-item {
      display: inline-block;
      width: 2px;
      height: 30px;
      margin: 10px 0;
      &.active {
        background-color: #00A6F4;
      }
    }
  }
}

</style>
